import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { getRefundStatusSeverity } from '../../vehiclesForSale/utils/statusBadges';

const RefundOrdersTable = ({ data = [], loading = false, activeTabKey, onView }) => {
    const { th, getCurrentLocale } = useLanguage();

    const formatDate = (value) => {
        if (!value) return '-';
        try {
            return new Date(value).toLocaleDateString(getCurrentLocale(), { day: '2-digit', month: '2-digit', year: 'numeric' });
        } catch {
            return value;
        }
    };

    const statusBody = (row) => {
        if (!row.statusText) return '-';
        return <Tag value={row.statusText} severity={getRefundStatusSeverity(row.status)} />;
    };

    const actionBodyTemplate = (rowData) => (
        <div className="flex align-items-center gap-1">
            <Button
                icon="pi pi-eye"
                className="p-button-text p-button-rounded p-button-info"
                onClick={() => onView?.(rowData)}
                tooltip={th('vehicleRefundOrders.buttons.detail')}
                tooltipOptions={{ position: 'top' }}
            />
        </div>
    );

    return (
        <DataTable
            value={data}
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25, 50]}
            loading={loading}
            showGridlines
            stripedRows
            responsiveLayout="scroll"
            emptyMessage={th('common.noRecords')}
            dataKey="id"
            className="p-datatable-gridlines"
        >
            <Column
                header={th('vehicleRefundOrders.columns.actions')}
                body={actionBodyTemplate}
                style={{ minWidth: '70px', width: '70px' }}
                frozen
                alignFrozen="left"
            />
            <Column field="dmsRefundNumber" header={th('vehicleRefundOrders.columns.dmsRefundNumber')} sortable style={{ minWidth: '140px' }} />
            <Column field="dmsOrderNumber" header={th('vehicleRefundOrders.columns.dmsOrderNumber')} sortable style={{ minWidth: '140px' }} />
            <Column field="chassisNo" header={th('vehicleRefundOrders.columns.chassisNo')} sortable style={{ minWidth: '150px' }} />
            <Column field="matnr" header={th('vehicleRefundOrders.columns.matnr')} sortable style={{ minWidth: '120px' }} />
            <Column field="partyNumber" header={th('vehicleRefundOrders.columns.partyNumber')} sortable style={{ minWidth: '120px' }} />
            <Column field="currency" header={th('vehicleRefundOrders.columns.currency')} sortable style={{ minWidth: '100px' }} />
            <Column
                field="deliveryDate"
                header={th('vehicleRefundOrders.columns.deliveryDate')}
                body={(row) => formatDate(row.deliveryDate)}
                sortable
                style={{ minWidth: '130px' }}
            />
            <Column field="quantity" header={th('vehicleRefundOrders.columns.quantity')} sortable style={{ minWidth: '80px' }} />
            <Column
                field="statusText"
                header={th('vehicleRefundOrders.columns.status')}
                body={statusBody}
                sortable
                style={{ minWidth: '130px' }}
            />
            <Column field="note" header={th('vehicleRefundOrders.columns.note')} sortable style={{ minWidth: '180px' }} />
            {activeTabKey === 'rejected' && (
                <Column field="rejectReason" header={th('vehicleRefundOrders.columns.rejectReason')} sortable style={{ minWidth: '180px' }} />
            )}
            <Column
                field="createdDate"
                header={th('vehicleRefundOrders.columns.createdDate')}
                body={(row) => formatDate(row.createdDate)}
                sortable
                style={{ minWidth: '130px' }}
            />
            <Column field="createdName" header={th('vehicleRefundOrders.columns.createdName')} sortable style={{ minWidth: '130px' }} />
            <Column field="bosBranchCode" header={th('vehicleRefundOrders.columns.bosBranchCode')} sortable style={{ minWidth: '120px' }} />
        </DataTable>
    );
};

export default RefundOrdersTable;
